import baart from './baart';
import vortex from './vortex';

export default {
  baart,
  vortex
};



// WEBPACK FOOTER //
// ./src/config/themes/index.js